export const activeTargetKey = (
  target: Pick<TPSActiveSubtestTarget, "kind" | "subtest_id">
) => `${target.kind}:${target.subtest_id}`;

export const isActiveTarget = (
  control: TPSActiveSubtestControl | null,
  target: Pick<TPSActiveSubtestTarget, "kind" | "subtest_id">
) =>
  control?.active?.kind === target.kind &&
  control.active.subtest_id === target.subtest_id;

export const progressSummary = (progress: TPSActiveSubtestProgress) =>
  `Total peserta: ${progress.participant_count}. Belum mulai: ${progress.not_started}. ` +
  `Sedang mengerjakan: ${progress.in_progress}. Selesai: ${progress.completed}.`;

export const isExplicitNoOpenSubtestError = (error: unknown) => {
  const response = (error as {
    response?: { status?: number; data?: { code?: string; message?: string } };
  })?.response;
  return (
    response?.data?.code === "NO_OPEN_SESSION" ||
    (response?.status === 400 && response?.data?.message === "no open session")
  );
};

export const captureSubtestIntent = (
  control: TPSActiveSubtestControl,
  target: TPSActiveSubtestTarget
): TPSActiveSubtestIntent => ({
  operation: isActiveTarget(control, target) ? "close" : "open",
  target,
});

export const decideSubtestIntent = (
  intent: TPSActiveSubtestIntent,
  control: TPSActiveSubtestControl
): TPSActiveSubtestIntentDecision => {
  const targetIsActive = isActiveTarget(control, intent.target);
  if (intent.operation === "open") {
    return targetIsActive ? "satisfied" : "proceed";
  }
  if (targetIsActive) return "proceed";
  return control.active === null ? "satisfied" : "state_changed";
};

export const createCoalescedRequestState = () => {
  let inFlight = false;
  let queued = false;
  return {
    request: () => {
      if (inFlight) {
        queued = true;
        return false;
      }
      inFlight = true;
      return true;
    },
    complete: () => {
      if (queued) {
        queued = false;
        return true;
      }
      inFlight = false;
      return false;
    },
  };
};

/** Parse psikotest WS payload (raw JSON or { body: string }). */
export const parsePsikotestWsPayload = (raw: unknown): Record<string, unknown> | null => {
  if (typeof raw !== "string") return null;
  try {
    const envelope = JSON.parse(raw);
    const payload =
      typeof envelope?.body === "string" ? JSON.parse(envelope.body) : envelope;
    if (!payload || typeof payload !== "object") return null;
    return payload as Record<string, unknown>;
  } catch {
    return null;
  }
};

/** PIC Form: refresh when another client opens/closes a subtest on this assessment. */
export const shouldRefreshSubtestControlFromWs = (
  payload: Record<string, unknown> | null,
  assessmentId: number
) => {
  if (!payload) return false;
  if (payload.scope !== "psikotest") return false;
  if (payload.action !== "check open session") return false;
  const messageAssessmentId = payload.assessment_id;
  if (messageAssessmentId === undefined || messageAssessmentId === null) {
    return false;
  }
  return Number(messageAssessmentId) === assessmentId;
};
